<form [formGroup]="emailFormGroup">


  <div class="card card--one bg-white mg-btm-30 ">
    <h2 class="card-title-top">Descarga de certificado del trabajador</h2>
    <h3 class="card-title-top-sub">Formato .pdf</h3>
    <div class="col-xs-12">
      <div class="icon-living-place shadow-item">
        <em class="material-icons icon-head">
          library_books
        </em>
      </div>
      <div class="header-card d-flex bottom-xs border-bottom">
        <h2 class="color-blue-light header-card_title u-medium mg-btm-20 f-16 title-card-option">Información de producto</h2>
      </div>
    </div>
    <ul class="list-data list-data--two ">
      <li class="d-flex middle-xs wow fadeInDown text-center justify-content-center">
        <div class="col-xs-12 col-sm-2 pdd-x-5 hide-down--md">
          <a  appDebounceClick id="Descarga_PTPC-Certificado Afiliación trabajadores" title="Imprimir" class="mg-btm-30  u-btn--light u-btn--blueLight u-btn u-btn--small u-btn--icon"
            (click)="printAffiliationWindow()">
            {{printing ? 'Processando..' : 'Imprimir'}}
          </a>
        </div>
        <div class="col-xs-12 col-lg-2 col-md-3 pdd-x-5 col-sm-3 p-0">
          <a
          appDebounceClick id="Descarga_PTPC-Certificado Afiliación trabajadores" title="Descargar"
          class="mg-btm-30 u-btn--light u-btn--blueLight u-btn u-btn--small u-btn--icon"
            [ngClass]="{'bg-blue': !downloading, 'bg-yellow': downloading}"
            (click)="printAffiliation()">
            {{downloading ? 'Descargando...' : 'Descargar'}}
          </a>
        </div>
        <div class="mg-btm-30 col-xs-12 col-sm-3 col-lg-5 p-0">
          <input aria-label="Por favor indique el correo electrónico para enviar su certificado" type="text" class="input--regular" placeholder="Correo electronico" id="email" required
            formControlName="email" maxlength="100" [(ngModel)]="sendEmail" pattern="[a-zA-Z0-9_-]+([.][a-zA-Z0-9_-]+)*@[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)*[.][a-zA-Z]{2,5}$">
        </div>
        <div class="col-xs-12 col-lg-3 col-md-4 col-sm-4 pdd-x-5 p-0">
          <button type="button"
          appDebounceClick id="Descarga_PTPC-Certificado Afiliación trabajadores" title="Enviar por correo"
          class="mg-btm-30 u-btn--light u-btn u-btn--blue u-btn--small u-btn--icon"
            (click)="affiliationGenerate()" [disabled]="!emailFormGroup.valid || sending">
            <em class="material-icons f-left">mail</em>
            {{sending ? 'Enviando...' : 'Enviar por correo'}}</button>
        </div>
      </li>
    </ul>
  </div>
</form>

<div class="col-xs-12">
  <div class="pad-sm-none d-flex justify-content-center text-center">
    <h2 class="col-xs-12 u-regular mg-btm-30 f-20">
      Has finalizado ¿Qué quieres hacer?
    </h2>

    <!-- <div class="col-xs-12 col-sm-4">
      <a class="u-btn--light u-btn u-btn--yellow u-btn--small u-btn--icon mg-btm-30"><i
          class="material-icons">navigate_next</i>Consultar estado aprobación</a>
    </div> -->
    <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 p-0">
      <a
      appDebounceClick id="Descarga_PTPC-Certificado Afiliación trabajadores" title="Cargar otro afiliado"
      [routerLink]="afiliacion" class="u-btn--light u-btn u-btn--line u-btn--small u-btn--icon mg-btm-30">
        Cargar otro afiliado
      </a>
    </div>

    <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3 p-0">
      <a
      appDebounceClick id="Descarga_PTPC-Certificado Afiliación trabajadores" title="Volver al inicio"
      [routerLink]="home" class="u-btn--light u-btn u-btn--line u-btn--small u-btn--icon mg-btm-30">
        Volver al inicio
      </a>
    </div>
  </div>
</div>

<div class="alert alert-success" *ngIf="alert == 'si'">
  <em class="material-icons">
    check_circle
  </em>

  <span class="pd-l-10 p-l-5">
    Correo electrónico enviado correctamente
  </span>
</div>

<div class="alert alert-failed" *ngIf="alert == 'no'">
  <em class="material-icons">
    cancel
  </em>

  <span class="pd-l-10 p-l-5">
    Error enviando el correo electrónico. Inténtelo de nuevo!
  </span>
</div>
